import React from 'react';
import { Button } from '../ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export function PaginationBar({ page, totalPages, total, pageSize, onChange, testIdPrefix = 'pagination' }) {
  if (total === 0) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100" data-testid={`${testIdPrefix}-bar`}>
      <p className="text-sm text-gray-600" data-testid={`${testIdPrefix}-info`}>
        Showing <span className="font-medium">{from}</span>–<span className="font-medium">{to}</span> of <span className="font-medium">{total}</span>
      </p>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" disabled={page <= 1}
          onClick={() => onChange(page - 1)} data-testid={`${testIdPrefix}-prev`}>
          <ChevronLeft className="h-4 w-4 mr-1" /> Previous
        </Button>
        <span className="text-sm text-gray-700 px-2" data-testid={`${testIdPrefix}-page-indicator`}>
          Page {page} of {totalPages}
        </span>
        <Button variant="outline" size="sm" disabled={page >= totalPages}
          onClick={() => onChange(page + 1)} data-testid={`${testIdPrefix}-next`}>
          Next <ChevronRight className="h-4 w-4 ml-1" />
        </Button>
      </div>
    </div>
  );
}
